import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { AppBar, Tab, Tabs } from '@material-ui/core';

import { useAppParams } from '@klp/core/app/useAppParams';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

import { ContractManagementTabs } from '../classes';
import { ContractManagementRoutes, getLekoEnable } from '../config';

const contractManagementAppBarStyles = () => ({
    appBar: {
        marginTop: '30px',
        marginBottom: '30px',
    },
    tab: {
        fontWeight: 400,
    },
});

export const ContractManagementAppBar: React.FC = () => {
    const { t } = useTranslation();
    const classes = useKlpStyles({}, contractManagementAppBarStyles);
    const history = useHistory();
    const params = useAppParams();
    const { tab } = params;

    useEffect(() => {
        if (
            !tab ||
            !Object.values(ContractManagementTabs).includes(
                tab as ContractManagementTabs,
            )
        ) {
            history.replace(
                ContractManagementRoutes.tab(ContractManagementTabs.avtaler),
            );
        }
    }, [tab, history]);

    const activeTab =
        tab &&
        Object.values(ContractManagementTabs).includes(
            tab as ContractManagementTabs,
        )
            ? tab
            : ContractManagementTabs.avtaler;

    return (
        <AppBar position="relative" className={classes.appBar}>
            <Tabs
                indicatorColor="secondary"
                textColor="secondary"
                variant="scrollable"
                orientation="horizontal"
                scrollButtons="on"
                value={activeTab}
            >
                <Tab
                    label={t('contractManagement.avtaler')}
                    component={Link}
                    to={ContractManagementRoutes.tab(
                        ContractManagementTabs.avtaler,
                    )}
                    value={ContractManagementTabs.avtaler}
                    className={classes.tab}
                />
                {getLekoEnable() && (
                    <Tab
                        label={t('contractManagement.leko')}
                        component={Link}
                        to={ContractManagementRoutes.tab(
                            ContractManagementTabs.levendekontrakter,
                        )}
                        value={ContractManagementTabs.levendekontrakter}
                        className={classes.tab}
                    />
                )}
            </Tabs>
        </AppBar>
    );
};
